/**
 * @name monitor-pc
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTVINGEyIDIgMCAwMS0yLTJWN2EyIDIgMCAwMTItMmg2IiAvPgogIDxwYXRoIGQ9Ik0xMCAxOUg1IiAvPgogIDxwYXRoIGQ9Ik0xNCAxMWg4IiAvPgogIDxwYXRoIGQ9Ik0xNCA3aDgiIC8+CiAgPHBhdGggZD0iTTE4IDE3aC4wMSIgLz4KICA8cGF0aCBkPSJNOSAxOXYtNCIgLz4KICA8cmVjdCB4PSIxNCIgeT0iMyIgd2lkdGg9IjgiIGhlaWdodD0iMTgiIHJ4PSIxIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/monitor-pc
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const MonitorPc: string = `
<svg
  class="lucide lucide-monitor-pc"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M10 15H4a2 2 0 01-2-2V7a2 2 0 012-2h6" />
  <path d="M10 19H5" />
  <path d="M14 11h8" />
  <path d="M14 7h8" />
  <path d="M18 17h.01" />
  <path d="M9 19v-4" />
  <rect x="14" y="3" width="8" height="18" rx="1" />
</svg>
`;

export default MonitorPc;
